import { FormModeConfig, FormModeDefaults } from '../../../base/interfaces/formModes'
import { ProductoInputProps } from '../interfaces/producto.interface'

export type ProductoFormMode = 'create' | 'edit' | 'consult'

/**
 * Configuración por defecto según el modo activo
 */
export const productoFormModeDefault: FormModeDefaults<ProductoFormMode> = {
  create: { disabled: false },
  edit: { disabled: false },
  consult: { disabled: true },
}

/**
 * Reglas específicas por campo del formulario de productos
 */
export const productoFormModelConfig: FormModeConfig<ProductoInputProps, ProductoFormMode> = {
  codigoProducto: {
    create: { disabled: false },
    edit: { disabled: true }, // El código de producto no suele modificarse al editar
    consult: { disabled: true },
  },
  nombre: {
    create: { disabled: false },
    edit: { disabled: false },
    consult: { disabled: true },
  },
  tipoProducto: {
    create: { disabled: false },
    edit: { disabled: false },
    consult: { disabled: true },
  },
  precio: {
    create: { disabled: false },
    edit: { disabled: false },
    consult: { disabled: true },
  },
}
